var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesting2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1768 19.9371C13.1768 12.7921 18.9689 7 26.1139 7H64.2396C71.3846 7 77.1768 12.7921 77.1768 19.9371V58.0629C77.1768 65.2079 71.3846 71 64.2396 71H26.1139C18.9689 71 13.1768 65.2079 13.1768 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 7.40428H64.2396C71.1613 7.40428 76.7725 13.0154 76.7725 19.9371V58.0629C76.7725 64.9846 71.1613 70.5957 64.2396 70.5957H26.1139C19.1922 70.5957 13.581 64.9846 13.581 58.0629V19.9371C13.581 13.0154 19.1922 7.40428 26.1139 7.40428Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0815 42.3691V35.3C53.0812 34.9901 52.9994 34.6857 52.8443 34.4174C52.6892 34.1491 52.4662 33.9263 52.1978 33.7713L46.0124 30.2368C45.7437 30.0817 45.439 30 45.1288 30C44.8185 30 44.5138 30.0817 44.2451 30.2368L38.0597 33.7713C37.7913 33.9263 37.5683 34.1491 37.4132 34.4174C37.2582 34.6857 37.1763 34.9901 37.176 35.3V42.3691C37.1763 42.679 37.2582 42.9834 37.4132 43.2517C37.5683 43.52 37.7913 43.7428 38.0597 43.8978L44.2451 47.4323C44.5138 47.5874 44.8185 47.6691 45.1288 47.6691C45.439 47.6691 45.7437 47.5874 46.0124 47.4323L52.1978 43.8978C52.4662 43.7428 52.6892 43.52 52.8443 43.2517C52.9994 42.9834 53.0812 42.679 53.0815 42.3691Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4533",
    x: 0.239647,
    y: 0.531445,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4533",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting2);
export default __webpack_public_path__ + "static/media/Testing2.4580f54b04ba39263e3e8641d1a46dc3.svg";
export { ForwardRef as ReactComponent };